// extracted by mini-css-extract-plugin
export var _default = "wrapper-module--_default--FITW-";
export var hero_clinic = "wrapper-module--hero_clinic--7nRja";
export var hero_doctor = "wrapper-module--hero_doctor--8hO48";
export var hero_general = "wrapper-module--hero_general--m00az";
export var hero_patient = "wrapper-module--hero_patient---7bYg";
export var primary = "wrapper-module--primary---D5AG";
export var secondary = "wrapper-module--secondary--TBalR";
export var wrapper = "wrapper-module--wrapper--Lr4aN";
export var wrapper_display = "wrapper-module--wrapper_display--x8TZ-";
export var wrapper_general_text = "wrapper-module--wrapper_general_text--g+-z+";
export var wrapper_vertical = "wrapper-module--wrapper_vertical--bH1eA";